import { render } from "./ReteRicambiDisplay.vue?vue&type=template&id=2e68ee9b"
import script from "./ReteRicambiDisplay.vue?vue&type=script&lang=js"
export * from "./ReteRicambiDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__